import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../rootReducer';

export const AiAgents = { DEEP_SEARCH: 'deepSearch' };

interface AgentRequestState {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
}

interface SliceState {
  agents: Record<string, AgentRequestState>;
}

const blank: AgentRequestState = { isLoading: false, isSuccess: false, isError: false };

const initialState: SliceState = {
  agents: Object.values(AiAgents).reduce((acc, key) => {
    acc[key] = { ...blank };
    return acc;
  }, {} as Record<string, AgentRequestState>),
};

const aiAgentStatesSlice = createSlice({
  // 🔑 This name is only for Redux‑DevTools; it does *not* affect the state path
  name: 'aiAgentStates',
  initialState,
  reducers: {
    setAgentLoading:  (s, a: PayloadAction<string>) => { s.agents[a.payload] = { isLoading: true,  isSuccess: false, isError: false }; },
    setAgentSuccess:  (s, a: PayloadAction<string>) => { s.agents[a.payload] = { isLoading: false, isSuccess: true,  isError: false }; },
    setAgentError:    (s, a: PayloadAction<string>) => { s.agents[a.payload] = { isLoading: false, isSuccess: false, isError: true  }; },
    resetAgentState:  (s, a: PayloadAction<string>) => { s.agents[a.payload] = { ...blank }; },
  },
});

export const {
  setAgentLoading,
  setAgentSuccess,
  setAgentError,
  resetAgentState,
} = aiAgentStatesSlice.actions;

/** Selector – path now matches the key we'll register in the root reducer */
export const selectAgentState =
  (agent: string) => (state: RootState) => state.aiAgentStates.agents[agent];

export default aiAgentStatesSlice.reducer;
